import classes from "./Profile.module.css"
import { useTranslation } from "react-i18next"
import Tabs from "./Tabs"
import { useState } from "react"
import SettingsPage from "./ProfileSettings"
import BadgePage from "./BadgeProgress"
import BadgeProgressUpdate from "./BadgeProgressUpdate"
import SeedListing from "./SeedListing"

const Profile = props => {
    const [activeTab, setActiveTab] = useState(0)
    const { t } = useTranslation()

    const get_tab_content = () => {
        switch (activeTab) {
            case 0:
                return <SettingsPage />
            case 1:
                return <BadgePage />
            case 2:
                return <BadgeProgressUpdate />
            case 3:
                return <SeedListing />
            default:
                return <SettingsPage />
        }
    }

    return (
        <>
            <h1>{t("misc:Profile.Profile")}</h1>
            <div className={classes.Wrapper}>
                <Tabs clicked={setActiveTab} active={activeTab} />
                {get_tab_content()}
            </div>
        </>
    )
}

export default Profile
